import { render, staticRenderFns } from "./Smartfarm2.vue?vue&type=template&id=1f1029c5&"
import script from "./Smartfarm2.vue?vue&type=script&lang=js&"
export * from "./Smartfarm2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports